<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<nb-layout>
  <nb-layout-header>
    <ngx-header></ngx-header>
  </nb-layout-header>
  <nb-layout-column>
    <div class="login-signup alert-msg">
      <header class="login-header">
        <h2 class="text-white">Reset your password</h2>
      </header>
      <form [formGroup]="passwordDetails" (ngSubmit)="resetPassword()">
        <mat-form-field class="full-width">
          <input type="password" matInput class="form-control" required placeholder="Password"
            formControlName="password" [(ngModel)]="password">
        </mat-form-field>
        <div *ngIf="passwordDetails.controls.password.touched && passwordDetails.controls.password.errors"
          class="error">
          <div *ngIf="passwordDetails.controls.password.errors.required">
            <div class="alert custom-alert-danger" role="alert">
              <span class="sr-only">Error:</span>
              Password is required
            </div>
          </div>
          <div *ngIf="passwordDetails.controls.password.errors.pattern">
            <div class="alert custom-alert-danger" role="alert">
              <span class="sr-only">Error:</span>
              Password must be of 8 character long having
              at least one upper case ,one lower case ,one digit,one special character from (#?!@$%^&*-.).
            </div>
          </div>
        </div>
        <mat-form-field class="full-width">
          <input type="password" matInput class="form-control" required placeholder="Confirm Password"
            formControlName="conformPassword" [compareEqual]="password">
        </mat-form-field>
        <div *ngIf="passwordDetails.controls.conformPassword.touched && passwordDetails.controls.conformPassword.errors"
          class="error">
          <div *ngIf="passwordDetails.controls.conformPassword.errors.required">
            <div class="alert custom-alert-danger" role="alert">
              <span class="sr-only">Error:</span>
              Confirm Password is required
            </div>
          </div>
          <div *ngIf="passwordDetails.controls.conformPassword.errors.compareEqual">
            <div class="alert custom-alert-danger" role="alert">
              <span class="sr-only">Error:</span>
              Password Do Not Match.
            </div>
          </div>
        </div>
        <button type="submit" class="btn btn-info full-width">Reset Password</button>
      </form>
    </div>
  </nb-layout-column>
</nb-layout>